import { DexEntityTypeEnum, DexEntityTypeEnumType, DexRegionEnumType } from '@mark43/cad-api';

export function useShouldShowAttentionField(
    dexEntityType: DexEntityTypeEnumType,
    dexRegion?: DexRegionEnumType,
    inquiryTypeCode?: string
): boolean {
    //AZ_ACJIS: Show attention only for Person DH (Driver History) queries
    if (dexRegion === 'AZ_ACJIS' && dexEntityType === DexEntityTypeEnum.PERSON.name) {
        return inquiryTypeCode === 'DH';
    }
    
    //For other regions, show attention field by default
    return true;
}
